// Textes de l'appli. La v1 est en français seulement (05, « Hors v1 ») ; i18next
// est gardé pour qu'une autre langue ne demande qu'un fichier. Les textes sont
// dans le paquet (pas de chargement réseau) : l'appli s'affiche hors ligne. Les
// textes légaux (fr-legal.json) viennent avec leur page (ecrans/PageTexte.tsx, #43).
import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';

void i18next
  .use(ICU)
  .use(initReactI18next)
  .init({
    lng: 'fr',
    fallbackLng: 'fr',
    supportedLngs: ['fr'],
    ns: ['common'],
    defaultNS: 'common',
    resources: { fr: { common: fr } },
    interpolation: { escapeValue: false },
    initAsync: false,
  });

document.documentElement.lang = 'fr';

export const i18n = i18next;
